/**
 * Created by Darius on 2016.08.07.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Paper } from 'material-ui';


class ServerMessages extends Component {
    constructor(props, context) {
        super(props, context);
    }

    renderMessages(messages) {
        return messages.map(function(item, index){
            return (<div key={index}>{item}</div>);
        });
    }

    render() {
        const {messages} = this.props;
        return (
            <Paper>
                <div className="dashboard-messages-list">
                    {this.renderMessages(messages)}
                </div>
            </Paper>
        );
    }
}

const mapStateToProps = state => ({
    lastMessage: state.dashboard.messages ? state.dashboard.messages[0] : '',
    messages: state.dashboard.messages || []
});

ServerMessages = connect(mapStateToProps)(ServerMessages);

export default ServerMessages;